var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatDocx = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10701_3153)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_10701_3153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79976C5.14879 32 2.99976 29.851 2.99976 27.2V4.8C2.99976 2.14903 5.14879 0 7.79976 0H16.4708C17.7309 0 18.9406 0.495552 19.8385 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8507 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79976C5.48016 31.4 3.59976 29.5196 3.59976 27.2V4.8C3.59976 2.4804 5.48016 0.6 7.79976 0.6H16.4708C17.5734 0.6 18.6318 1.03361 19.4175 1.80722L27.1465 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10701_3153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_10701_3153",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H27.8164C29.4733 14 30.8164 15.3431 30.8164 17V25C30.8164 26.6569 29.4733 28 27.8164 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H27.8164C29.4733 14 30.8164 15.3431 30.8164 17V25C30.8164 26.6569 29.4733 28 27.8164 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#0579D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H27.8164C29.9151 13.2 31.6164 14.9013 31.6164 17H30.0164C30.0164 15.785 29.0314 14.8 27.8164 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM30.8164 28H0H30.8164ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM27.8164 13.2C29.9151 13.2 31.6164 14.9013 31.6164 17V24.2C31.6164 26.2987 29.9151 28 27.8164 28C29.0314 28 30.0164 26.6569 30.0164 25V17C30.0164 15.785 29.0314 14.8 27.8164 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_10701_3153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16875 24.2H3V17.8H5.2125C5.84792 17.8 6.39375 17.9281 6.85 18.1844C7.30833 18.4386 7.66042 18.8042 7.90625 19.2813C8.15208 19.7584 8.275 20.3292 8.275 20.9938C8.275 21.6604 8.15104 22.2334 7.90313 22.7125C7.65729 23.1917 7.30208 23.5594 6.8375 23.8156C6.375 24.0719 5.81875 24.2 5.16875 24.2ZM4.15938 23.1969H5.1125C5.55833 23.1969 5.93021 23.1156 6.22813 22.9531C6.52604 22.7886 6.75 22.5438 6.9 22.2188C7.05 21.8917 7.125 21.4834 7.125 20.9938C7.125 20.5042 7.05 20.0979 6.9 19.775C6.75 19.45 6.52813 19.2073 6.23438 19.0469C5.94271 18.8844 5.58021 18.8031 5.14688 18.8031H4.15938V23.1969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0953 21C15.0953 21.6896 14.9661 22.2802 14.7078 22.7719C14.4516 23.2615 14.1016 23.6365 13.6578 23.8969C13.2161 24.1573 12.7151 24.2875 12.1547 24.2875C11.5943 24.2875 11.0922 24.1573 10.6484 23.8969C10.2068 23.6344 9.85677 23.2584 9.59844 22.7688C9.34219 22.2771 9.21406 21.6875 9.21406 21C9.21406 20.3104 9.34219 19.7209 9.59844 19.2313C9.85677 18.7396 10.2068 18.3636 10.6484 18.1031C11.0922 17.8427 11.5943 17.7125 12.1547 17.7125C12.7151 17.7125 13.2161 17.8427 13.6578 18.1031C14.1016 18.3636 14.4516 18.7396 14.7078 19.2313C14.9661 19.7209 15.0953 20.3104 15.0953 21ZM13.9297 21C13.9297 20.5146 13.8536 20.1052 13.7016 19.7719C13.5516 19.4365 13.3432 19.1834 13.0766 19.0125C12.8099 18.8396 12.5026 18.7531 12.1547 18.7531C11.8068 18.7531 11.4995 18.8396 11.2328 19.0125C10.9661 19.1834 10.7568 19.4365 10.6047 19.7719C10.4547 20.1052 10.3797 20.5146 10.3797 21C10.3797 21.4854 10.4547 21.8959 10.6047 22.2313C10.7568 22.5646 10.9661 22.8177 11.2328 22.9906C11.4995 23.1615 11.8068 23.2469 12.1547 23.2469C12.5026 23.2469 12.8099 23.1615 13.0766 22.9906C13.3432 22.8177 13.5516 22.5646 13.7016 22.2313C13.8536 21.8959 13.9297 21.4854 13.9297 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6695 19.9594H20.5008C20.4674 19.7677 20.406 19.5979 20.3164 19.45C20.2268 19.3 20.1154 19.1729 19.982 19.0688C19.8487 18.9646 19.6966 18.8865 19.5258 18.8344C19.357 18.7802 19.1747 18.7531 18.9789 18.7531C18.631 18.7531 18.3227 18.8406 18.0539 19.0156C17.7852 19.1886 17.5747 19.4427 17.4227 19.7781C17.2706 20.1115 17.1945 20.5188 17.1945 21C17.1945 21.4896 17.2706 21.9021 17.4227 22.2375C17.5768 22.5709 17.7872 22.8229 18.0539 22.9938C18.3227 23.1625 18.6299 23.2469 18.9758 23.2469C19.1674 23.2469 19.3466 23.2219 19.5133 23.1719C19.682 23.1198 19.8331 23.0438 19.9664 22.9438C20.1018 22.8438 20.2154 22.7209 20.307 22.575C20.4008 22.4292 20.4654 22.2625 20.5008 22.075L21.6695 22.0813C21.6258 22.3854 21.531 22.6709 21.3852 22.9375C21.2414 23.2042 21.0529 23.4396 20.8195 23.6438C20.5862 23.8459 20.3133 24.0042 20.0008 24.1188C19.6883 24.2313 19.3414 24.2875 18.9602 24.2875C18.3977 24.2875 17.8956 24.1573 17.4539 23.8969C17.0122 23.6365 16.6643 23.2604 16.4102 22.7688C16.156 22.2771 16.0289 21.6875 16.0289 21C16.0289 20.3104 16.157 19.7209 16.4133 19.2313C16.6695 18.7396 17.0185 18.3636 17.4602 18.1031C17.9018 17.8427 18.4018 17.7125 18.9602 17.7125C19.3164 17.7125 19.6477 17.7625 19.9539 17.8625C20.2602 17.9625 20.5331 18.1094 20.7727 18.3031C21.0122 18.4948 21.2091 18.7302 21.3633 19.0094C21.5195 19.2865 21.6216 19.6031 21.6695 19.9594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5883 17.8L24.9977 20.1438H25.0477L26.4633 17.8H27.7852L25.8133 21L27.8164 24.2H26.4727L25.0477 21.8719H24.9977L23.5727 24.2H22.2352L24.257 21L22.2602 17.8H23.5883Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10701_3153",
    x: 1.39976,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10701_3153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10701_3153",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10701_3153"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10701_3153",
    x: 0,
    y: 14,
    width: 30.8164,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10701_3153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10701_3153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatDocx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatDocx.c75d256d53501003319a491f5cd8c587.svg";